import "bootstrap/js/dist/alert";
